import { useEffect, useState } from "react";
import axios from "axios";
import InvoiceList from "./InvoiceList";
import InvoiceDetails from "./InvoiceDetails";
import { BASE_URL } from "../../../../config/api";

/* ---------- map LIST api → UI invoice ---------- */
function mapInvoiceList(apiInv) {
  const total = Number(apiInv.invoice_amount || 0);
  const balance = Number(apiInv.balance_amount || 0);

  return {
    invoice_id: apiInv.invoice_id,
    invoice_number: apiInv.invoice_number,
    reference_number:
      apiInv.zoho_json?.reference_number || apiInv.invoice_number,

    date: apiInv.invoice_date,
    due_date: apiInv.due_date,

    status: apiInv.invoice_status,
    current_sub_status: apiInv.invoice_status,

    total,
    balance,
    payment_made: total - balance,

    customer_id: apiInv.contact_id,
    customer_name: apiInv.customer_name || apiInv.org_name,

    email: apiInv.email,
    phone: apiInv.org_mobile,

    invoice_url: apiInv.invoice_url,

    currency_code:
      apiInv.zoho_json?.currency_code || "INR",

    currency_symbol:
      apiInv.zoho_json?.currency_symbol || "₹",

    // EXTRA RESPONSE DATA
    location_id: apiInv.location_id,
    location_name: apiInv.location_name,

    product_type: apiInv.product_type,
    company_id: apiInv.company_id,

    created_by_id: apiInv.created_by_id,
    created_by_name: apiInv.created_by_name,

    payment_date: apiInv.payment_date,
    payment_expected_date: apiInv.payment_expected_date,

    due_days: apiInv.due_days,

    org_code: apiInv.org_code,
    org_name: apiInv.org_name,

    role: apiInv.role,
    user_id: apiInv.user_id,

    write_off_amount: apiInv.write_off_amount,

    state: apiInv.state,
    district: apiInv.district,
    taluka: apiInv.taluka,
    pincode: apiInv.pincode,

    zoho_last_modified_at: apiInv.zoho_last_modified_at,

    // FULL ZOHO JSON IF NEEDED
    zoho_json: apiInv.zoho_json,
  };
}

/* ---------- map DETAILS api → UI invoice ---------- */
export function mapInvoiceDetails(apiData) {
  const z = apiData.zoho;

  return {
    invoice_id: z.invoice_id,
    invoice_number: z.invoice_number,
    reference_number: z.reference_number,

    date: z.date,
    due_date: z.due_date,
    last_payment_date: z.last_payment_date,

    status: z.status,
    current_sub_status: z.current_sub_status,

    total: z.total,
    balance: z.balance,
    payment_made: z.total - z.balance,

    customer_id: z.customer_id,
    customer_name: z.customer_name,
    email: z.email,
    contact_number: z.phone,

    contact_person: {
      name: z.billing_address?.attention,
      phone: z.billing_address?.phone,
      email: z.email,
    },

    billing_address: {
      street: z.billing_address?.address,
      street2: z.billing_address?.street2,
      city: z.billing_address?.city,
      state: z.billing_address?.state,
      zip: z.billing_address?.zipcode,
      country: z.billing_address?.country,
      phone: z.billing_address?.phone,
      attention: z.billing_address?.attention,
    },

    line_items: z.line_items || [],

    sub_total: z.total,
    tax_total: 0,
    discount_total: 0,
    adjustment: z.adjustment,
    write_off_amount: z.write_off_amount,

    created_time: z.created_time,
    last_modified_time: z.last_modified_time,
    created_by_name: z.created_by,

    template_name: "Zoho Invoice",
    invoice_url: z.invoice_url,
    currency_code: z.currency_code,
    currency_symbol: z.currency_symbol,
  };
}

export default function InvoicePage({
  effectiveRole,
  targetId,
  data,
}) {
  // const authUserString = localStorage.getItem("authUserData");
  // const authUser = authUserString ? JSON.parse(authUserString) : null;

  // const role = Number(authUser?.role);
  // const company_id = authUser?.id;
  // const user_id = authUser?.id;

  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [invoiceStatus, setInvoiceStatus] = useState("all");

//   useEffect(() => {
//   async function loadInvoices() {
//     if (!effectiveRole || !targetId) return;

//     setLoading(true);

//     try {
//       const params = {
//         page: currentPage,
//       };

//       // role based params
//       if (effectiveRole === 2) {
//         params.company_id = targetId;
//       }

//       if (effectiveRole === 5) {
//         params.user_id = targetId;
//       }

//       // ✅ SEARCH PARAM
//       if (debouncedSearch) {
//         params.invoice_number = debouncedSearch;
//       }

//       // ✅ STATUS PARAM
//       if (invoiceStatus !== "all") {
//         params.invoice_status = invoiceStatus;
//       }

//       const res = await axios.get(
//         `${BASE_URL}zoho/get-invoices`,
//         { params }
//       );

//       const payload = res.data.data;

//       setInvoices(payload.data.map(mapInvoiceList));
//       setTotalPages(payload.last_page);
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setLoading(false);
//     }
//   }

//   loadInvoices();
// }, [effectiveRole, targetId, currentPage, debouncedSearch, invoiceStatus]);


useEffect(() => {
  async function loadInvoices() {
    if (!effectiveRole || !targetId) return;

    setLoading(true);

    try {
      const authUser = JSON.parse(
        localStorage.getItem("authUserData") || "{}"
      );

      const localRole = Number(authUser?.role);

      const params = {
        page: currentPage,
      };

      // ✅ ADMIN → only location_id
      if (localRole === 1) {
        params.location_id = authUser?.location_id;
      }

      // ✅ COMPANY
      if (effectiveRole === 2) {
        params.company_id = targetId;
      }

      // ✅ RETAILER
      if (effectiveRole === 5) {
        params.location_id =
          data?.location_id || authUser?.location_id;

        params.contact_id =
          data?.zoho_id || authUser?.zoho_id;

        params.user_id = targetId;
      }

      // ✅ SEARCH PARAM
      if (debouncedSearch) {
        params.invoice_number = debouncedSearch;
      }

      // ✅ STATUS PARAM
      if (invoiceStatus !== "all") {
        params.invoice_status = invoiceStatus;
      }

      const res = await axios.get(
        `${BASE_URL}zoho/get-invoices`,
        { params }
      );

      const payload = res.data;

      setInvoices(payload.data.map(mapInvoiceList));
      setTotalPages(payload.last_page);

    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  loadInvoices();
}, [
  effectiveRole,
  targetId,
  currentPage,
  debouncedSearch,
  invoiceStatus,
]);


useEffect(() => {
  const timer = setTimeout(() => {
    if (search.length >= 4) {
      setDebouncedSearch(search);
      setCurrentPage(1);
    } else if (search.length === 0) {
      setDebouncedSearch("");
    }
  }, 500); // 500ms debounce

  return () => clearTimeout(timer);
}, [search]);


  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading…</div>;
  }

  return (
    <InvoiceList
      invoices={invoices}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      search={search}
      setSearch={setSearch}
      invoiceStatus={invoiceStatus}
      setInvoiceStatus={setInvoiceStatus}
    />

  );
}




// import { useEffect, useState } from "react";
// import axios from "axios";
// import InvoiceList from "./InvoiceList";
// import InvoiceDetails from "./InvoiceDetails";
// import { BASE_URL } from "../../../../config/api";

// /* ---------- map LIST api → UI invoice ---------- */
// function mapInvoiceList(apiInv) {
//   const total = Number(apiInv.invoice_amount || 0);
//   const balance = Number(apiInv.balance_amount || 0);

//   return {
//     invoice_id: apiInv.invoice_id,
//     invoice_number: apiInv.invoice_number,
//     reference_number: apiInv.invoice_number,

//     date: apiInv.invoice_date,
//     due_date: apiInv.due_date,

//     status: apiInv.invoice_status,
//     current_sub_status: apiInv.invoice_status,

//     total,
//     balance,
//     payment_made: total - balance,

//     customer_id: apiInv.contact_id,
//     customer_name: apiInv.org_name,
//     email: "",

//     invoice_url: apiInv.invoice_url,
//     currency_code: "INR",
//     currency_symbol: "₹",
//   };
// }

// /* ---------- map DETAILS api → UI invoice ---------- */
// function mapInvoiceDetails(apiData) {
//   const z = apiData.zoho;

//   return {
//     invoice_id: z.invoice_id,
//     invoice_number: z.invoice_number,
//     reference_number: z.reference_number,

//     date: z.date,
//     due_date: z.due_date,
//     last_payment_date: z.last_payment_date,

//     status: z.status,
//     current_sub_status: z.current_sub_status,

//     total: z.total,
//     balance: z.balance,
//     payment_made: z.total - z.balance,

//     customer_id: z.customer_id,
//     customer_name: z.customer_name,
//     email: z.email,
//     contact_number: z.phone,

//     contact_person: {
//       name: z.billing_address?.attention,
//       phone: z.billing_address?.phone,
//       email: z.email,
//     },

//     billing_address: {
//       street: z.billing_address?.address,
//       street2: z.billing_address?.street2,
//       city: z.billing_address?.city,
//       state: z.billing_address?.state,
//       zip: z.billing_address?.zipcode,
//       country: z.billing_address?.country,
//       phone: z.billing_address?.phone,
//       attention: z.billing_address?.attention,
//     },

//     line_items: z.line_items || [],

//     sub_total: z.total,
//     tax_total: 0,
//     discount_total: 0,
//     adjustment: z.adjustment,
//     write_off_amount: z.write_off_amount,

//     created_time: z.created_time,
//     last_modified_time: z.last_modified_time,
//     created_by_name: z.created_by,

//     template_name: "Zoho Invoice",
//     invoice_url: z.invoice_url,
//     currency_code: z.currency_code,
//     currency_symbol: z.currency_symbol,
//   };
// }

// export default function InvoicePage() {
//   /* ---------- localStorage ---------- */
//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = authUserString ? JSON.parse(authUserString) : null;

//   const role = Number(authUser?.role);          // 2 or 5
//   const company_id = authUser?.company_id;      // for role 2
//   const user_id = authUser?.id;                 // for role 5

//   const [page, setPage] = useState("list");
//   const [loading, setLoading] = useState(false);
//   const [invoices, setInvoices] = useState([]);
//   const [invoice, setInvoice] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
// const [totalPages, setTotalPages] = useState(1);


//   /* ---------- LIST API ---------- */
//   useEffect(() => {
//   async function loadInvoices() {
//     if (!role) return;

//     setLoading(true);
//     try {
//       const params =
//         role === 2
//           ? { company_id, page: currentPage }
//           : { user_id, page: currentPage };

//       const res = await axios.get(
//         `${BASE_URL}zoho/get-invoices`,
//         { params }
//       );

//       const payload = res.data.data;

//       setInvoices(payload.data.map(mapInvoiceList));
//       setCurrentPage(payload.current_page);
//       setTotalPages(payload.last_page);
//     } catch (e) {
//       console.error("Invoice list error", e);
//     } finally {
//       setLoading(false);
//     }
//   }

//   loadInvoices();
// }, [role, company_id, user_id, currentPage]);


//   /* ---------- DETAILS API ---------- */
//   async function openInvoice(invoice_id) {
//     setPage("detail");
//     setLoading(true);

//     try {
//       const res = await axios.get(
//         `${BASE_URL}zoho/get-invoices-by-id`,
//         { params: { invoice_id } }
//       );

//       setInvoice(mapInvoiceDetails(res.data.data));
//     } catch (e) {
//       console.error("Invoice details error", e);
//     } finally {
//       setLoading(false);
//       window.scrollTo?.(0, 0);
//     }
//   }

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center text-sm text-slate-600">
//         Loading invoices…
//       </div>
//     );
//   }

//   return page === "list" ? (
//      <InvoiceList
//     invoices={invoices}
//     onView={openInvoice}
//     currentPage={currentPage}
//     totalPages={totalPages}
//     onPageChange={setCurrentPage}
//   />
//   ) : (
//     <InvoiceDetails invoice={invoice} onBack={() => setPage("list")} />
//   );
// }


// import React, { useMemo, useState } from "react";
// import InvoiceList from "./InvoiceList";
// import InvoiceDetails from "./InvoiceDetails";
// import { moneyINR, prettyDate, statusLabel, statusTone, isPayEnabled } from "./invoiceUtils";

// export default function InvoicePage() {
//   const invoices = useMemo(
//       () => [
//         {
//           invoice_id: "3310518000000243002",
//           invoice_number: "INV-000106",
//           reference_number: "WTY-52-pay_SD9psTHYgSBagp",
//           date: "2026-02-07",
//           due_date: "2026-02-07",
//           status: "paid",
//           current_sub_status: "paid",
//           invoice_source: "Api",
//           currency_code: "INR",
//           currency_symbol: "₹",
//           sub_total: 3199.8,
//           tax_total: 0,
//           discount_total: 0,
//           total: 3199.8,
//           payment_made: 3199.8,
//           balance: 0,
//           last_payment_date: "2026-02-07",
//           customer_id: "3310518000000167001",
//           contact_number: "CUS-00004",
//           customer_name: "Rupesh Retailer",
//           email: "deepali.kadam@goelectronix.co.in",
//           contact_person: {
//             name: "Rupesh Mukesh Sharma",
//             phone: "7039475973",
//             email: "deepali.kadam@goelectronix.co.in",
//           },
//           billing_address: {
//             street: "abx",
//             street2: "jhsd",
//             city: "MUMBAI SUBURBAN",
//             state: "MAHARASHTRA",
//             zip: "400074",
//             country: "India",
//             phone: "7039475973",
//             attention: "Rupesh Mukesh Sharma",
//           },
//           notes: "Thanks for your business.",
//           credits_applied: 0,
//           adjustment: 0,
//           write_off_amount: 0,
//           line_items: [
//             {
//               name: "Screen Damage Android",
//               description: "test product",
//               quantity: 1,
//               rate: 3199.8,
//               item_total: 3199.8,
//               tax_percentage: 0,
//               discount: 0,
//             },
//           ],
//           invoice_url:
//             "https://zohosecurepay.in/books/rohitcompany/secure?CInvoiceID=2-0f8f57538f56650f414f96ad64717f129af6c3ea2057fb534b3f8f40de49788b9057e736cc2b175b8e85d18a4329aa7b408245b6a32028ede278f06f43fee2a7bf747bf136c83d3b",
//           created_time: "2026-02-07T12:01:30+0530",
//           last_modified_time: "2026-02-07T12:16:33+0530",
//           created_by_name: "Rohit Kamble",
//           template_name: "Standard Template",
//         },
//         {
//           invoice_id: "3310518000000243999",
//           invoice_number: "INV-000107",
//           reference_number: "WTY-53-pay_XY1mockRef",
//           date: "2026-02-05",
//           due_date: "2026-02-05",
//           status: "sent",
//           current_sub_status: "overdue",
//           invoice_source: "Api",
//           currency_code: "INR",
//           currency_symbol: "₹",
//           sub_total: 2499,
//           tax_total: 0,
//           discount_total: 0,
//           total: 2499,
//           payment_made: 0,
//           balance: 2499,
//           last_payment_date: "",
//           customer_id: "3310518000000167001",
//           contact_number: "CUS-00004",
//           customer_name: "Rupesh Retailer",
//           email: "deepali.kadam@goelectronix.co.in",
//           contact_person: {
//             name: "Rupesh Mukesh Sharma",
//             phone: "7039475973",
//             email: "deepali.kadam@goelectronix.co.in",
//           },
//           billing_address: {
//             street: "abx",
//             street2: "jhsd",
//             city: "MUMBAI SUBURBAN",
//             state: "MAHARASHTRA",
//             zip: "400074",
//             country: "India",
//             phone: "7039475973",
//             attention: "Rupesh Mukesh Sharma",
//           },
//           notes: "Payment pending.",
//           credits_applied: 0,
//           adjustment: 0,
//           write_off_amount: 0,
//           line_items: [
//             {
//               name: "Warranty Extension",
//               description: "12 months plan",
//               quantity: 1,
//               rate: 2499,
//               item_total: 2499,
//               tax_percentage: 0,
//               discount: 0,
//             },
//           ],
//           invoice_url:
//             "https://zohosecurepay.in/books/rohitcompany/secure?CInvoiceID=2-mock-overdue",
//           created_time: "2026-02-05T10:11:30+0530",
//           last_modified_time: "2026-02-05T10:11:30+0530",
//           created_by_name: "Rohit Kamble",
//           template_name: "Standard Template",
//         },
//         {
//           invoice_id: "3310518000000244888",
//           invoice_number: "INV-000108",
//           reference_number: "WTY-54-pay_ZZ2mockRef",
//           date: "2026-02-06",
//           due_date: "2026-02-06",
//           status: "partial",
//           current_sub_status: "partial",
//           invoice_source: "Api",
//           currency_code: "INR",
//           currency_symbol: "₹",
//           sub_total: 5999,
//           tax_total: 0,
//           discount_total: 0,
//           total: 5999,
//           payment_made: 2000,
//           balance: 3999,
//           last_payment_date: "2026-02-06",
//           customer_id: "3310518000000167001",
//           contact_number: "CUS-00004",
//           customer_name: "Rupesh Retailer",
//           email: "deepali.kadam@goelectronix.co.in",
//           contact_person: {
//             name: "Rupesh Mukesh Sharma",
//             phone: "7039475973",
//             email: "deepali.kadam@goelectronix.co.in",
//           },
//           billing_address: {
//             street: "abx",
//             street2: "jhsd",
//             city: "MUMBAI SUBURBAN",
//             state: "MAHARASHTRA",
//             zip: "400074",
//             country: "India",
//             phone: "7039475973",
//             attention: "Rupesh Mukesh Sharma",
//           },
//           notes: "Partial payment received.",
//           credits_applied: 0,
//           adjustment: 0,
//           write_off_amount: 0,
//           line_items: [
//             {
//               name: "Combo Plan",
//               description: "Screen + Warranty",
//               quantity: 1,
//               rate: 5999,
//               item_total: 5999,
//               tax_percentage: 0,
//               discount: 0,
//             },
//           ],
//           invoice_url:
//             "https://zohosecurepay.in/books/rohitcompany/secure?CInvoiceID=2-mock-partial",
//           created_time: "2026-02-06T09:01:30+0530",
//           last_modified_time: "2026-02-06T09:01:30+0530",
//           created_by_name: "Rohit Kamble",
//           template_name: "Standard Template",
//         },
//       ],
//       []
//     );

//   const [page, setPage] = useState("list");
//   const [selectedId, setSelectedId] = useState(invoices[0]?.invoice_id || "");
//   const [copied, setCopied] = useState(false);

//    const [q, setQ] = useState("");
//     const [statusFilter, setStatusFilter] = useState("all");
//     const [customerFilter, setCustomerFilter] = useState("all");
//     const [sortBy, setSortBy] = useState("date_desc");

//   const invoice = useMemo(
//     () => invoices.find((x) => x.invoice_id === selectedId) || invoices[0],
//     [invoices, selectedId]
//   );

//   async function copyLink(url) {
//     try {
//       await navigator.clipboard.writeText(url);
//       setCopied(true);
//       setTimeout(() => setCopied(false), 1200);
//     } catch {
//       setCopied(false);
//       alert("Copy not allowed in this environment. Please copy manually.");
//     }
//   }

//   const customers = useMemo(() => {
//       const m = new Map();
//       for (const inv of invoices) {
//         const key = inv.customer_id;
//         if (!m.has(key)) {
//           m.set(key, {
//             customer_id: inv.customer_id,
//             name: inv.customer_name,
//             email: inv.email,
//           });
//         }
//       }
//       return Array.from(m.values()).sort((a, b) => String(a.name).localeCompare(String(b.name)));
//     }, [invoices]);

//     const filtered = useMemo(() => {
//         const needle = q.trim().toLowerCase();
//         let out = invoices.slice();
    
//         if (customerFilter !== "all") out = out.filter((x) => x.customer_id === customerFilter);
    
//         if (statusFilter !== "all") {
//           out = out.filter((x) => statusLabel(x).toLowerCase() === statusFilter);
//         }
    
//         if (needle) {
//           out = out.filter((x) => {
//             const blob = [
//               x.invoice_number,
//               x.invoice_id,
//               x.reference_number,
//               x.customer_name,
//               x.email,
//               x.contact_number,
//               x.contact_person?.phone,
//             ]
//               .filter(Boolean)
//               .join(" ")
//               .toLowerCase();
//             return blob.includes(needle);
//           });
//         }
    
//         const dateVal = (s) => {
//           const d = new Date(String(s || ""));
//           const t = d.getTime();
//           return Number.isNaN(t) ? 0 : t;
//         };
    
//         out.sort((a, b) => {
//           if (sortBy === "date_asc") return dateVal(a.date) - dateVal(b.date);
//           if (sortBy === "total_desc") return Number(b.total || 0) - Number(a.total || 0);
//           if (sortBy === "total_asc") return Number(a.total || 0) - Number(b.total || 0);
//           return dateVal(b.date) - dateVal(a.date);
//         });
    
//         return out;
//       }, [invoices, q, statusFilter, customerFilter, sortBy]);

//   const kpis = useMemo(() => {
//       const sum = (arr, fn) => arr.reduce((a, x) => a + Number(fn(x) || 0), 0);
//       const total = sum(filtered, (x) => x.total);
//       const paid = sum(filtered, (x) => x.payment_made);
//       const balance = sum(filtered, (x) => x.balance);
//       const overdueCount = filtered.filter((x) => statusLabel(x) === "OVERDUE").length;
//       return { total, paid, balance, count: filtered.length, overdueCount };
//     }, [filtered]);

//   return page === "list" ? (
//     <InvoiceList
//       invoices={invoices}
//       onView={(id) => {
//         setSelectedId(id);
//         setPage("detail");
//         window.scrollTo?.(0, 0);
//       }}

//       copyLink={copyLink}
//       kpis={kpis}
//       customers={customers}
//       filtered={filtered}
//     />
//   ) : (
//     <InvoiceDetails
//       invoice={invoice}
//       onBack={() => setPage("list")}
//     />
//   );
// }
